import PropTypes from 'prop-types';
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { localdb, localUsers } from '../util/localDbUtil';
import AuthenticationModalView from '../views/dss/AuthenticationModalView';
import { SignInSignUpProvider } from './v2/SignInSignUpProvider';
import SwitchUserModalView from '../views/dss/SwitchUserModalView';
import { axiosHttp } from '../wrapper/AxiosWrapper';
import ForceLogoutModalView from '../views/dss/ForceLogoutModalView';

const AuthenticationContext = createContext({});
const excluded_redirected_path = ["/dss"]

const AuthenticationProvider = ({ children }) => {
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [showSwitchUserModal, setShowSwitchUserModal] = useState(false);
    const [showForceLogOutModal, setShowForceLogOutModal] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const openLoginModal = () => setShowLoginModal(true);
    const closeLoginModal = () => setShowLoginModal(false);

    const openSwitchUserModal = () => setShowSwitchUserModal(true);
    const closeSwitchUserModal = () => setShowSwitchUserModal(false);

    const openForceLogOutModal = () => setShowForceLogOutModal(true);
    const closeForceLogOutModal = () => setShowForceLogOutModal(false);


    useEffect(() => {
        handleResponseErrors(openLoginModal, logout, openForceLogOutModal);
    }, []);


    const login = (switchUser = false) => {
        if (!switchUser) {
            setRedirectPath(location.pathname);
        }
        openLoginModal();
    }
    const switchAccount = () => {
        openSwitchUserModal();
    }

    const logedInSuccess = (data, redirect=true) => {
        if (showLoginModal) {
            closeLoginModal();
        }
        data.user.loggedOn = Date.now();
        data.user.authToken = data.authToken;
        localUsers.addUser(data.user);
        localUsers.setActiveUser(data.user);

        let redirectPath = getRedirectPath();
        if (redirectPath && redirect) {
            navigate(redirectPath);
        } else {
            //navigate("/");
        }
    };

    const isLoggedIn = () => {
        let user = localUsers.getActiveUser();
        return user && user.authToken;
    }

    const getUser = () => {
        return localUsers.getActiveUser();
    }

    const setActiveUser = (userId) => {
        let userData = localUsers.getUser(userId);
        if (userData) {
            localUsers.setActiveUser(userData);
            navigate("/");
        }
    }
    
    const logout = () => {
        let user = localUsers.getActiveUser();
        localUsers.deleteUser(user.id);
        localUsers.clearActiveUser();

        localdb.remove("redirectPath");
        setUserData(null);
        navigate("/");
    };

    const [userData, setUserData] = useState(getUser());

    const memoObj = useMemo(() => ({ login, logedInSuccess, logout, isLoggedIn, getUser, userData, switchAccount, setActiveUser, closeLoginModal }), 
    [userData, isLoggedIn]);
    return (
        <AuthenticationContext.Provider value={memoObj}>
            {children}
            {/* <LoginModalView open={showLoginModal} close={closeLoginModal} />*/}
            {showLoginModal &&

                <SignInSignUpProvider>
                    <AuthenticationModalView open={showLoginModal} close={closeLoginModal} />
                </SignInSignUpProvider>
            }

            {showSwitchUserModal &&
                <SwitchUserModalView open={showSwitchUserModal} close={closeSwitchUserModal} />
            }

            {showForceLogOutModal &&
                <ForceLogoutModalView open={showForceLogOutModal} close={closeForceLogOutModal} />
            }

        </AuthenticationContext.Provider>
    )
}
AuthenticationProvider.propTypes = {
    children: PropTypes.string.isRequired,
};

const useAuthentication = () => {
    return useContext(AuthenticationContext);
}

export { AuthenticationProvider, useAuthentication };

const setRedirectPath = (redirectPath) => {
    let pathArr = excluded_redirected_path.filter(path => redirectPath.startsWith(path));
    if (!pathArr || pathArr.length === 0) {
        localdb.put("redirectPath", redirectPath);
    }

}

const getRedirectPath = (path) => {
    return localdb.get("redirectPath");
}

const handleResponseErrors = (openLoginModal, logout, openForceLogOutModal)=>{
    const responseInterceptor = axiosHttp.interceptors.response.use(response =>{ 
                return response
           
        }, (error) => {
            if (error.status === 401){//authentication
                 //openLoginModal();
            }else if(error.status === 403){//Forbidden force logout
                openForceLogOutModal();
                logout();
            }else if(error.status === 404){//No Found
            }else if("ERR_NETWORK" === error.code){
            }else if(error.response && error.response.status === 503 ){//Service unavailable
                //underMaintenanceModal();
            }else{
               // toggleError(true, error);// all other internal errors
               //errorModal();
            }
            return Promise.reject(error)
        })

        return () => {
            axiosHttp.interceptors.response.eject(responseInterceptor);
        }
}

